import React from 'react'
import { LoadingIndicator } from '@sainsburys-tech/fable'
import { PropTypes } from 'prop-types'

const loadingOverlay = (props) => {
  const { text, hasBackground, size } = props
  const label = text || undefined

  return (
    <div className={hasBackground ? 'c-loadingOverlay-background' : 'c-loadingOverlay'}>
      <LoadingIndicator isLoading label={label} size={size} />
    </div>
  )
}


loadingOverlay.propTypes = {
  text: PropTypes.string,
  hasBackground: PropTypes.bool,
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
}

loadingOverlay.defaultProps = {
  text: null,
  hasBackground: false,
  size: 'xl'
}

export default loadingOverlay
